export const SymfonyModuleHttpClientConfig: { observe: 'response'; } = {
  observe: 'response'
};
